import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'CustomizedAutoSync'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST_ASYNC', typeKey)
export const SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC = createAsyncTypes(
  'SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC',
  typeKey
)

export const SET_INTEGRATION_TYPE = `${typeKey}/SET_INTEGRATION_TYPE`

export const PAGINATE_CHANGE = `${typeKey}/PAGINATE_CHANGE`

export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SEARCH_RESET = `${typeKey}/SEARCH_RESET`
export const SYNC_ALL_UPDATE = `${typeKey}/SYNC_ALL_UPDATE`
export const GROUP_TOGGLE = `${typeKey}/GROUP_TOGGLE`
export const SHARED_MAILBOXES_CHANGE = `${typeKey}/SHARED_MAILBOXES_CHANGE`
export const SELECT_ALL = `${typeKey}/SELECT_ALL`
export const UNSELECT_ALL = `${typeKey}/UNSELECT_ALL
`
export const FORM_RESET = `${typeKey}/FORM_RESET`
